import React, { PureComponent } from 'react'
import ReactHowler from 'react-howler'
import { connect } from 'react-redux'
import audioSelector from '../../redux/selectors/app/audioSelector'
import { IStore } from '../../redux/reducers/index'

interface IAudioElementProps {
	isMuted: boolean
	loop?: boolean
	src: string
	path: string
	volume: number
}

class AudioElement extends PureComponent<IAudioElementProps> {
	static defaultProps = {
		loop: true,
	}

	render() {
		return (
			<ReactHowler
				playing={true}
				loop={this.props.loop}
				volume={this.props.isMuted ? 0 : this.props.volume}
				src={this.props.path + this.props.src}
			/>
		)
	}
}

const mapStateToProps = (state: IStore) => {
	return audioSelector(state)
}

export default connect(mapStateToProps)(AudioElement)
